"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _cartApi = _interopRequireDefault(require("../../cartApi.js"));
var _cartIconSVG = _interopRequireDefault(require("./cartIconSVG.js"));
var _consts = require("../consts.js");
var _utils = require("../../utils/utils");
var _photographyClientLib = require("@wix/photography-client-lib");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// const wixFullstoryLoader = require('wix-fullstory-loader');
// wixFullstoryLoader({label: 'artstore-cart-icon'});
var CartIcon = /*#__PURE__*/function (_Component) {
  function CartIcon(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.state = {
      initialized: false,
      cartIcon: null,
      cartIconText: null,
      cartItemsCount: 0,
      connectedProviders: _photographyClientLib.window.connectedProviders
    };
    _photographyClientLib.Wix.addEventListener(_photographyClientLib.Wix.Events.EDIT_MODE_CHANGE, function (result) {
      if (result.editMode === 'preview') {
        _photographyClientLib.Wix.PubSub.publish('reCreateCartForm', {}, false);
      }
    });
    _photographyClientLib.Wix.addEventListener(_photographyClientLib.Wix.Events.PAGE_NAVIGATION, function (result) {
      _cartApi["default"].createCartForm();
    });
    _photographyClientLib.Wix.PubSub.subscribe('reCreateCartForm', function (data) {
      _cartApi["default"].createCartForm();
    });
    _photographyClientLib.Wix.PubSub.subscribe(_consts.ARTSTORE_PUBSUB_ENUMS.REFRESH_CART, function () {
      _this.updateItemsCount();
    }, true);
    _cartApi["default"].createCartForm();
    _photographyClientLib.Wix.Styles.getStyleParams(_this.setStyleParams.bind(_this));
    _photographyClientLib.Wix.addEventListener(_photographyClientLib.Wix.Events.STYLE_PARAMS_CHANGE, _this.setStyleParams.bind(_this));
    _photographyClientLib.Wix.Data.Public.get('cartIconText', {
      scope: 'COMPONENT'
    }, _this.setCartIconText.bind(_this));
    _photographyClientLib.Wix.addEventListener(_photographyClientLib.Wix.Events.PUBLIC_DATA_CHANGED, _this.setCartIconText.bind(_this));
    _this.updateItemsCount();
    _this.showCartForm = _this.showCartForm.bind(_this);
    _this.handleKeyDown = _this.handleKeyDown.bind(_this);
    return _this;
  }
  (0, _inheritsLoose2["default"])(CartIcon, _Component);
  var _proto = CartIcon.prototype;
  _proto.setCartIconText = function setCartIconText(_ref) {
    var cartIconText = _ref.cartIconText;
    this.setState({
      cartIconText: cartIconText
    });
  };
  _proto.setStyleParams = function setStyleParams(_ref2) {
    var fonts = _ref2.fonts,
      numbers = _ref2.numbers,
      colors = _ref2.colors;
    var color8 = _photographyClientLib.Wix.Styles.getColorByreference('color-8').value;
    var getIconColor = function getIconColor(param) {
      return param && param.value || color8;
    };
    var getFont = function getFont(param) {
      var font = param && param || _photographyClientLib.Wix.Styles.getStyleFontByReference('Body-M');
      return font.value.replace('font:', '');
    };
    var cartIcon = this.getCartIcon(Number(numbers.cartIcon));
    // const cartIconFont = getFont(fonts.cartIconFont)
    // const cartIconFontColor = getColor(colors.cartIconFontColor)
    var cartIconColor = getIconColor(colors.cartIconColor);
    this.setState({
      cartIcon: cartIcon,
      cartIconColor: cartIconColor,
      initialized: true
    });
  };
  _proto.getCartIcon = function getCartIcon(num) {
    var icons = ['cart', 'cartOutline', 'bag', 'bagOutline', 'cartText'];
    return num >= 0 ? icons[num] : icons[3];
  };
  _proto.updateItemsCount = function updateItemsCount() {
    var _this2 = this;
    var connectedProviders = this.state.connectedProviders;
    var connectedProviderId = Object.keys(connectedProviders)[0];

    // In some cases there may not be a providerId (when cart appears before gallery had a chance to provision)
    if (connectedProviderId) {
      _cartApi["default"].getCartItems(connectedProviderId).then(function (arrItems) {
        var count = _cartApi["default"].getCartItemsCount(arrItems);
        _this2.setState({
          cartItemsCount: count
        });
      });
    }
  };
  _proto.handleKeyDown = function handleKeyDown(e) {
    switch (e.keyCode || e.charCode) {
      case 32: // space
      case 13:
        // enter
        e.preventDefault();
        e.stopPropagation();
        this.showCartForm();
        return false;
      default:
        break;
    }
    return true;
  };
  _proto.showCartForm = function showCartForm() {
    _cartApi["default"].showCart();
  };
  _proto.componentDidMount = function componentDidMount() {
    // window.fedopsAppName='art-store-cart'
    (0, _photographyClientLib.appLoaded)();
  };
  _proto.render = function render() {
    var _this$state = this.state,
      cartIcon = _this$state.cartIcon,
      cartIconText = _this$state.cartIconText,
      cartItemsCount = _this$state.cartItemsCount,
      cartIconColor = _this$state.cartIconColor;
    var cartCount = cartIcon === 'cartText' ? "(" + cartItemsCount + ")" : cartItemsCount;
    var cart = /*#__PURE__*/_react["default"].createElement("div", {
      onClick: this.showCartForm,
      onKeyDown: this.handleKeyDown,
      tabIndex: _utils.utils.getTabIndex('cartIcon'),
      "aria-label": "Cart (" + cartCount + ")",
      role: "button",
      className: "cart-icon " + (_utils.utils.isAccessibilityEnabled() ? 'accessible' : '')
    }, cartIcon === 'cartText' ? /*#__PURE__*/_react["default"].createElement("div", null, cartIconText) : /*#__PURE__*/_react["default"].createElement(_cartIconSVG["default"], {
      icon: cartIcon,
      color: cartIconColor
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "cart-icon-count"
    }, cartCount));
    return this.state.initialized ? cart : null;
  };
  return CartIcon;
}(_react.Component);
(0, _reactDom.render)(/*#__PURE__*/_react["default"].createElement(CartIcon, null), document.getElementById('cart-icon'));